module.exports = __webpack_public_path__ + "img/marquee-brands-1-1-768x326.8fd27267.png";